export default __webpack_public_path__ + "static/media/location.156dfc9d.png";